import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { CommonController } from '@classes/common.controller';
import { PdfExportService } from '@common/services/pdf-export.service';
import { marker } from '@common/translate-marker';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services/modal.service';
import { PcsDocumentAndApprovalServices } from '@services/pcs-document-and-approval-services.service';
import { PcsApprovalDetailsDisplayModel } from '../../../../../vessel-visit/vessel-visit-list/models/PcdDocumentAndApprovalModels/DetailsDisplayModels/PcsApprovalDetailsDisplayModel';
import { PcsDocumentOrApprovalUpdateGridDateDisplayModel } from '../../../../../vessel-visit/vessel-visit-list/models/PcdDocumentAndApprovalModels/OtherDisplayModels/PcsDocumentOrApprovalUpdateGridDateDisplayModel';
import { PcsDocumentOrApprovalLocation } from '../../models/PcsDocumentOrApprovalLocation';

@Component({
    selector: 'app-pcs-additional-approval',
    templateUrl: './pcs-additional-approval.component.html',
    styleUrls: ['./pcs-additional-approval.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PcsAdditionalApprovalComponent extends CommonController implements OnInit {
    @Input() approvalId: number;
    @Input() generalActStatusId = null;
    @Input() showApproveButtons: boolean = true;
    @Input() approvalLocation: PcsDocumentOrApprovalLocation;
    @Output() closeButton = new EventEmitter<void>();
    @Output() updateGridData = new EventEmitter<PcsDocumentOrApprovalUpdateGridDateDisplayModel>();
    @ViewChild('pdf', { static: false }) pdf: any;
    private pdfExport = inject(PdfExportService);
    printModel: any;
    printed = false;
    model: PcsApprovalDetailsDisplayModel;
    now: Date = new Date();

    isBusy = false;

    constructor(
        protected dialogService: ModalService,
        protected translateService: TranslateService,
        private service: PcsDocumentAndApprovalServices
    ) {
        super(dialogService, translateService);
    }

    ngOnInit(): void {
        this.isBusy = true;
        this.service.getPcsAdditionalApprovalDetailedData(this.approvalId).subscribe((response) => {
            this.model = response;
            this.isBusy = false;
        });
    }

    updatePcsApproval($event) {
        Object.assign(this.model, $event);
        this.updateGridData.emit({
            status: $event.pcsDocumentAndApprovalStatus,
            lastModifiedBy: $event.lastModifiedBy,
            lastModifiedDate: $event.lastModifiedDate,
            remarks: $event.remarks.length > 0,
            hasAttachments: $event.attachments?.length > 0,
            forOrganization: $event.forOrganization
        });
    }

    closeThisApproval(): void {
        this.closeButton.emit();
    }

    generatePdf(): void {
        this.service.getPcsApprovalPrintData(this.approvalId).subscribe((response) => {
            this.printModel = response;
            this.now = new Date();
            this.printed = true;
        });
    }

    onLogoLoaded() {
        setTimeout(() => {
            const lastModifiedDate = this.model.lastModifiedDate
                ? ' ' + new Date(this.model.lastModifiedDate).toISOString().slice(0, 16)
                : '';

            const fileName = `${this.translateService.instant(marker('PCS Approval Report'))} ${
                this.model.id
            }${lastModifiedDate}.pdf`;

            this.pdfExport.save(this.pdf, fileName).finally(() => (this.printed = false));
        }, 0);
    }
}
